import React from 'react';
import PropTypes from 'prop-types';
import { MenuButtonColumn } from 'react-md';

const KebabMenu = ({ menuItems, ...props }) => (
  <MenuButtonColumn {...props} icon menuItems={menuItems} listClassName="tables__with-menus__kebab-list" >
      more_vert
  </MenuButtonColumn>
);

KebabMenu.propTypes = {
  menuItems: PropTypes.array,
};


export default KebabMenu;



// WEBPACK FOOTER //
// ./src/components/KebabMenu.jsx